module.exports = __webpack_public_path__ + "img/thumbnail_Nilgai_f_leucistic.d3c6a6cf.png";